module.exports = __webpack_public_path__ + "img/fill-details.0e72e1dd.svg";